<div class="modal-header">
    <h4 class="modal-title" i18n>Asset</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
</div>
<div class="modal-body" [formGroup]="form">
    <div class="row g-3">
        <div class="col-5">
            <div class="row g-3">
                <div class="col-md-12">
                    <button type="button" class="btn btn-secondary btn-sm float-end" (click)="selectAllPlacements()"
                        i18n>Select all</button>
                    <label for="image" class="form-label" i18n>Placement</label>
                    <div class="row g-3">
                        <div class="col-6">
                            <div *ngFor="let placement of customerPlacements" class="form-check">
                                <input type="checkbox" class="form-check-input" [id]="placement"
                                    [formControlName]="placement">
                                <label [for]="placement" class="form-check-label">{{ placement | i18nSelect:
                                    adsCampaignAssetPlacements }}</label>
                            </div>
                        </div>
                        <div class="col-6">
                            <div *ngFor="let placement of employeePlacements" class="form-check">
                                <input type="checkbox" class="form-check-input" [id]="placement"
                                    [formControlName]="placement">
                                <label [for]="placement" class="form-check-label">{{ placement | i18nSelect:
                                    adsCampaignAssetPlacements }}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <label for="bid" class="form-label" i18n>Maximum bid</label>
                    <div class="input-group">
                        <input type="number" class="form-control" id="bid" formControlName="bid">
                        <span class="input-group-text">€</span>
                    </div>
                    <div class="text-muted small" i18n>Bid for selected placements</div>
                </div>
                <div class="col-md-12">
                    <label for="image" class="form-label" i18n>Image</label>
                    <input type="file" class="form-control" id="image" (change)="imageUpdate($event)">
                    <div class="text-muted small" i18n>512x512px recommended</div>
                </div>
                <div class="col-md-12">
                    <div class="input-group input-group-sm w-auto float-end">
                        <div class="input-group-text"><fa-icon [icon]="fa.faGlobe"></fa-icon></div>
                        <select id="language" class="form-select-sm w-auto" [(ngModel)]="previewLanguage"
                            [ngModelOptions]="{standalone: true}">
                            <option [ngValue]="null" i18n>English</option>
                            <option *ngFor="let language of translations" [value]="'_' + language">{{ language |
                                i18nSelect: languages }}</option>
                        </select>
                    </div>
                    <h5 class="mb-0" i18n>Preview</h5>
                </div>
                <div class="col-md-12">

                    <div class="card">
                        <div class="card-body d-flex align-items-top cursor-pointer" (click)="clickPreview()">
                            <img [src]="adsCampaignAsset.picture"
                                style="width: 3rem; height: 3rem; border-radius: 50%; object-fit: cover; object-position: center;"
                                class="me-3">
                            <div>
                                <div class="text-info fw-bold">{{ adsCampaign.ads_organization.display_name }}
                                </div>
                                <div style="white-space: pre-wrap;"
                                    [ngClass]="{'fst-italic': !form.controls['content'].value && !form.controls['content_' + previewLanguage]?.value}">
                                    {{ (form.controls['content' + (previewLanguage || '') ].value) ||
                                    form.controls['content'].value || yourContent }}</div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="col-7">
            <div class="row g-3">
                <div class="col-md-12">
                    <label for="content" class="form-label" i18n>Content (Engligh)</label>
                    <textarea rows="3" class="form-control" id="content" formControlName="content"></textarea>
                    <div class="text-danger small"
                        *ngIf="form.controls['content'].invalid && form.controls['content'].touched" i18n>Min 3, max 256
                        characters</div>
                </div>
                <div class="col-md-12">
                    <label for="url" class="form-label" i18n>Link (English)</label>
                    <input type="text" class="form-control" id="url" formControlName="url">
                    <div class="text-danger small" *ngIf="form.controls['url'].invalid && form.controls['url'].touched"
                        i18n>Please enter a valid URL</div>
                </div>

                <div class="col-md-12 mb-0">
                    <h5 class="mb-0" i18n>Translations</h5>
                </div>
                <ng-container *ngFor="let language of translations">
                    <div class="col-md-12">
                        <label [for]="'content_' + language" class="form-label" i18n>Content ({{language | i18nSelect:
                            languages}})</label>
                        <textarea rows="3" class="form-control" [id]="'content_' + language"
                            [formControlName]="'content_' + language"></textarea>
                    </div>
                    <div class="col-md-12">
                        <label [for]="'url_' + language" class="form-label" i18n>Link ({{language | i18nSelect:
                            languages}})</label>
                        <input type="text" class="form-control" [id]="'url_' + language"
                            [formControlName]="'url_' + language">
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-bs-toggle="dropdown"><fa-icon
            [icon]="fa.faEllipsis"></fa-icon></button>
    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
        <li><button type="button" class="dropdown-item" (click)="translate()" i18n>Translate texts</button></li>
    </ul>
    <button [disabled]="!form.valid" type="button" class="btn btn-primary" (click)="save()" i18n>Save</button>
    <button [disabled]="!adsCampaignAsset || !adsCampaignAsset.id" type="button" class="btn btn-danger"
        (click)="delete()" i18n>Delete</button>
    <button type="button" class="btn btn-secondary" (click)="activeModal.close()" i18n>Close</button>
</div>